import * as React from "react";

import { Link } from "gatsby";
import { useLoc } from "../../hooks/useLoc";
import { TemperatureUnitPicker } from "./unit-picker";

export const MobileMenu = () => {
    const loc = useLoc();
    // TODO localize blog
    return (
        <menu className="px-12 py-16 xm:px-16">
            {/* <li className="nav__item--mobile">
                                <Link to="/">{intl.formatMessage({id: 'header.howThingsWork'})}</Link>
                            </li> */}
            <MenuItem>
                <Link to="/about-us/">{loc("header.aboutSunheron")}</Link>
            </MenuItem>
            <MenuItem>
                <Link to="/faq/">{loc("header.FAQ")}</Link>
            </MenuItem>
            <MenuItem>
                <Link to="/contact/">{loc("header.contact")}</Link>
            </MenuItem>
            <MenuItem>
                <Link to="/blog/">Blog</Link>
            </MenuItem>
            <div className="w-28 min-w-[106px]">
                <TemperatureUnitPicker />
            </div>
            {/* <hr className="hr--m2" />
                            <div className="text--center">
                                <Link to="/">
                                    <button className="text--uppercase button button--primary button__text--thin m--auto w100">
                                        Přejít na vyhledávač dovolené
                                    </button>
                                </Link>
                            </div> */}
        </menu>
    );
};

const MenuItem = ({ children }) => {
    return <li className="mb-16 text-xl text-sh-red underline">{children}</li>;
};
